<button
  [routerLink]="[base, contextId, 'quick-history']"
  mat-menu-item
>
  <mat-icon>history</mat-icon>
  <span class="text">{{ T.MH.QUICK_HISTORY | translate }}</span>
</button>

<button
  [routerLink]="[base, contextId, 'worklog']"
  mat-menu-item
>
  <mat-icon>date_range</mat-icon>
  <span class="text">{{ T.MH.WORKLOG | translate }}</span>
</button>

@if (isForProject || contextId === TODAY_TAG_ID) {
  <button
    [routerLink]="[base, contextId, 'metrics']"
    mat-menu-item
  >
    <mat-icon>donut_large</mat-icon>
    <span class="text">{{ T.MH.METRICS | translate }}</span>
  </button>
}

@if (contextId === TODAY_TAG_ID) {
  <button
    (click)="unplanAllTodayTasks()"
    mat-menu-item
  >
    <mat-icon>event_busy</mat-icon>
    <span class="text">{{ T.MH.UNPLAN_ALL_TASKS | translate }}</span>
  </button>
}

<button
  (click)="shareTasksAsMarkdown()"
  mat-menu-item
>
  <mat-icon>{{ shareSupport === 'none' ? 'content_copy' : 'ios_share' }}</mat-icon>
  <span class="text">
    {{
      (shareSupport === 'none'
        ? T.MH.COPY_TASK_LIST_MARKDOWN
        : T.MH.SHARE_TASK_LIST_MARKDOWN
      ) | translate
    }}
  </span>
</button>

@if (isForProject || contextId === TODAY_TAG_ID) {
  <button
    (click)="addSection()"
    mat-menu-item
  >
    <mat-icon>list</mat-icon>
    <span class="text">{{ T.MH.ADD_SECTION | translate }}</span>
  </button>
}

@if (isForProject) {
  <button
    [matMenuTriggerFor]="projectValueMenu"
    mat-menu-item
  >
    <mat-icon>trending_up</mat-icon>
    <span class="text">{{ T.F.PROJECT.FORM_BASIC.L_VALUE | translate }}</span>
  </button>
  <button
    (click)="editProjectDeadline()"
    mat-menu-item
  >
    <mat-icon>event</mat-icon>
    <span class="text">{{ T.F.PROJECT.FORM_BASIC.L_DEADLINE | translate }}</span>
  </button>
  <mat-menu #projectValueMenu="matMenu">
    <button
      (click)="setProjectValue(null)"
      mat-menu-item
    >
      <span class="text">{{ T.F.TASK.CMP.CLEAR_VALUE | translate }}</span>
    </button>
    @for (value of taskScoreLevels; track value) {
      <button
        (click)="setProjectValue(value)"
        mat-menu-item
      >
        <span class="text">{{ taskValueLabels[value] }}</span>
      </button>
    }
  </mat-menu>
}

<button
  (click)="openSettings()"
  mat-menu-item
>
  <mat-icon>settings</mat-icon>
  <span class="text">{{ T.MH.SETTINGS | translate }}</span>
</button>

@if (!isForProject && contextId !== TODAY_TAG_ID) {
  <button
    (click)="deleteTag()"
    mat-menu-item
  >
    <mat-icon class="color-warn-i">delete_forever</mat-icon>
    <span class="text">{{ T.MH.DELETE_TAG | translate }}</span>
  </button>
}
@if (isForProject && contextId !== INBOX_PROJECT.id) {
  <button
    (click)="archiveProject()"
    mat-menu-item
  >
    <mat-icon>archive</mat-icon>
    <span class="text">{{ T.MH.ARCHIVE_PROJECT | translate }}</span>
  </button>
  <button
    (click)="duplicateProject()"
    mat-menu-item
  >
    <mat-icon>file_copy</mat-icon>
    <span class="text">{{ T.MH.DUPLICATE_PROJECT | translate }}</span>
  </button>
  <button
    (click)="deleteProject()"
    mat-menu-item
  >
    <mat-icon class="color-warn-i">delete_forever</mat-icon>
    <span class="text">{{ T.MH.DELETE_PROJECT | translate }}</span>
  </button>
}
